import { memo } from 'react';

import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

export type AnnouncementDismissButtonProps = {
  onDismiss: () => void;
};

export const AnnouncementDismissButton = memo(({ onDismiss }: AnnouncementDismissButtonProps) => {
  return (
    <IconButton
      adsIcon
      appearance="ghost"
      className="shrink-0"
      color="gray"
      data-testid="ANNOUNCEMENT_DISMISS_BUTTON"
      icon={XIcon}
      label="Dismiss announcement"
      onClick={onDismiss}
      size="small"
    />
  );
});

AnnouncementDismissButton.displayName = 'AnnouncementDismissButton';
